export * from '../tutorial/tutorial.component';
export * from '../tutorial/pre-cadastro/preCadastroVIdeo.component';
export * from '../tutorial/contrato/contratoVideo.component';
export * from '../tutorial/estoque/estoqueVideo.component';
export * from '../tutorial/financeiro/financeiroVideo.component';
export * from '../tutorial/projeto/projetoVideo.component';
export * from '../tutorial/permissao-acesso/permissaoAcessoVideo.component';
export * from '../tutorial/pessoa-instituicao/pessoaInstituicaoVideo.component';
export * from '../tutorial/rh/rhVideo.component';